import React, { useState, useEffect } from 'react';
import { Crown, Users, TrendingUp, Star } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL.replace(/^http:\/\//i, 'https://');

const TipsterOfTheDay = () => {
  const [tipster, setTipster] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTipster = async () => {
      try {
        const res = await fetch(`${API_URL}/api/social/tipster-of-the-day`);
        if (res.ok) {
          const data = await res.json();
          setTipster(data.tipster);
        }
      } catch { /* silent */ }
      finally { setLoading(false); }
    };
    fetchTipster();
  }, []);

  if (loading || !tipster) return null;

  return (
    <div data-testid="tipster-of-the-day" className="mb-4 bg-gradient-to-r from-[#FFD700]/10 via-[#1a2332] to-[#FFD700]/5 border border-[#FFD700]/20 rounded-xl p-4">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-full bg-[#FFD700]/10 flex items-center justify-center shrink-0">
          <Crown className="w-6 h-6 text-[#FFD700]" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-0.5">
            <span className="text-[10px] uppercase tracking-wider text-[#FFD700] font-bold">Tipster des Tages</span>
            <Star className="w-3 h-3 text-[#FFD700]" />
          </div>
          <div className="text-base font-bold text-white truncate">{tipster.anon_name}</div>
        </div>
        <div className="flex gap-4 shrink-0">
          <div className="text-center">
            <div className="text-sm font-bold text-[#00BFA6]">{tipster.score}</div>
            <div className="text-[10px] text-gray-500 flex items-center gap-0.5"><TrendingUp className="w-3 h-3" /> Score</div>
          </div>
          <div className="text-center">
            <div className="text-sm font-bold text-white">{tipster.tips_count}</div>
            <div className="text-[10px] text-gray-500">Tipps</div>
          </div>
          <div className="text-center">
            <div className="text-sm font-bold text-[#7B1FA2]">{tipster.followers}</div>
            <div className="text-[10px] text-gray-500 flex items-center gap-0.5"><Users className="w-3 h-3" /> Follower</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsterOfTheDay;
